<div class="ai-search-results">
  @if (loading()) {
  <div class="results-loading">
    <div class="spinner">
      <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
    </div>
    <p>Searching...</p>
  </div>
  } @else if (showInitialState) {
  <div class="results-initial">
    <div class="initial-icon">
      <i class="far fa-search"></i>
    </div>
    <h3>Search AQAs</h3>
    <p>Enter a search term above to find AQAs</p>
  </div>
  } @else if (showEmptyState) {
  <div class="results-empty">
    <div class="empty-icon">
      <i class="far fa-folder-open"></i>
    </div>
    <h3>No Results Found</h3>
    <p>Try adjusting your search terms or filters</p>
  </div>
  } @else {
  <div class="results-list">
    @for (result of results(); track trackByResultId($index, result)) {
    <app-aqa-search-result-card [item]="result" [showSender]="showSender" (viewClick)="viewClicked(result)"></app-aqa-search-result-card>
    }
  </div>
  }


  @if (selectedResult()) {
  <app-aqa-viewer [email]="selectedResult()!"
                  (closed)="onCloseViewer()" />
  }
</div>

        @if (showPager) {
<div class="ai-search-pagination">
  <ngb-pagination [page]="currentPage()"
                  [pageSize]="pageSize()"
                  [collectionSize]="totalCount()"
                  [maxSize]="5"
                  [boundaryLinks]="true"
                  (pageChange)="onPageChange($event)">
  </ngb-pagination>
</div>
        }



<app-loading-indicator [isLoading]="documentLoading"
                       [loadingMessage]="''">

</app-loading-indicator>
